// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__d3uZy","navSection":"PageHeader_navSection__1WhPz","socialLinks":"PageHeader_socialLinks__bGmSO"};